import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const V = (props) => (
  <Icon viewBox="0 0 13 10" {...props}>
    <g>
      <title>v</title>
      <path d="M1 5l3.898 4.084L12.186 0" stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" />
    </g>
  </Icon>
);
/*eslint-enable */

export default V;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/V.js